import { alpha, useTheme } from "@rentiohq/web-shared-next/dist/themes";
import { EFontWeights } from "@rentiohq/web-shared-next/dist/themes/types";
import { getSuccess200 } from "../../Payments.styles";

// Values follow the direct debit card in the Tenant Dashboard V2 Figma file.
export const DirectDebitsStyles = () => {
  const theme = useTheme();
  return {
    wrapper: (hasActiveDirectDebit: boolean) => ({
      backgroundColor: hasActiveDirectDebit
        ? alpha(getSuccess200(theme), 0.2)
        : theme.palette.common.white,
    }),
    content: {
      title: {
        fontSize: "14px",
        fontWeight: EFontWeights.Medium,
        lineHeight: "20px",
        color: alpha(theme.palette.grey[700], 0.6),
      },
      button: {
        alignSelf: "flex-start",
        px: 2,
        py: 1,
        fontSize: "12px",
        fontWeight: EFontWeights.Medium,
        lineHeight: "normal",
      },
    },
  };
};
